import { acquireAPItoken } from "../msalAuthConfig";

// Utility function to perform a GET request with Bearer token authentication
export async function fetchGetQuery(url, contentType = "application/json") {
  const bearerToken = await acquireAPItoken();
  try {
    const response = await fetch(`${process.env.REACT_APP_APIDOMAIN}${url}`, {
      method: "GET",
      headers: {
        "Content-Type": contentType,
        Authorization: `Bearer ${bearerToken}`,
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      const error = new Error(errorText || response.statusText);
      error.status = response.status;
      throw error;
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
}

//Utility function to perform a GET request with api-key from env
export async function fetchGetQueryWithApiKey(
  url,
  contentType = "application/json",
) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_APIDOMAIN_IMENIK}${url}`,
      {
        method: "GET",
        headers: {
          "Content-Type": contentType,
          PWD: process.env.REACT_APP_APIDOMAIN_IMENIK_KEY,
        },
      },
    );

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(
        `Error ${response.status}: ${errorText || response.statusText}`,
      );
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
}

// Utility function to perform a GET request and return a Blob, with Bearer token authentication
export async function fetchQueryBlob(url) {
  const bearerToken = await acquireAPItoken();
  try {
    const response = await fetch(`${process.env.REACT_APP_APIDOMAIN}${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${bearerToken}`,
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(
        `Error ${response.status}: ${errorText || response.statusText}`,
      );
    }
    // get contetn-disposition header to get filename
    const contentDisposition = response.headers.get("content-disposition");

    // Extract filename from content-disposition header
    let filename = "exportCsv.csv"; // Default filename
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename=([^;]+)/);
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1]; // Use extracted filename or default if extraction fails
      }
    }

    const blob = await response.blob();
    return { blob, filename };
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
}

// Utility function to perform a POST request with Bearer token authentication
export async function fetchPostQuery(url, body) {
  const bearerToken = await acquireAPItoken();
  try {
    const response = await fetch(`${process.env.REACT_APP_APIDOMAIN}${url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${bearerToken}`,
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(
        `Error ${response.status}: ${errorText || response.statusText}`,
      );
    }

    return null;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
}

// Utility function to perform a PUT request with Bearer token authentication
export async function fetchPutQuery(url, body) {
  const bearerToken = await acquireAPItoken();
  try {
    const response = await fetch(`${process.env.REACT_APP_APIDOMAIN}${url}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${bearerToken}`,
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(
        `Error ${response.status}: ${errorText || response.statusText}`,
      );
    }

    return null;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
}

export async function fetchDeleteQuery(url) {
  const bearerToken = await acquireAPItoken();
  try {
    const response = await fetch(`${process.env.REACT_APP_APIDOMAIN}${url}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${bearerToken}`,
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(
        `Error ${response.status}: ${errorText || response.statusText}`,
      );
    }

    return null;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
}
